<template>
    <div>
        <b-card>
            <b-card-body>
                <b-form-group>
                    <label>File</label>
                    <b-form-file v-model="file" size="lg" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." accept="text/csv, application/vnd.ms-excel" />
                    <b-button size="lg" block variant="success" class="mt-2" @click="submitHandler">
                        <b-icon-upload></b-icon-upload>
                        <span>Upload</span>
                    </b-button>
                </b-form-group>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { batchAddCustomer } from "@/services/AgentService";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { BButton, BCard, BCardBody, BCol, BForm, BFormFile, BFormGroup, BIconUpload, BRow } from 'bootstrap-vue';
import { ValidationObserver } from "vee-validate";

export default {
    name: "BatchAddCustomer",
    components: {
        ValidationObserver,
        BRow,
        BForm,
        BCol,
        BFormFile,
        ToastificationContent,
        BCardBody,
        BCard,
        BButton,
        BIconUpload,
        BFormGroup
    },
    data() {
        return {
            file: null
        }
    },
    methods: {
        async submitHandler() {
            if (!this.file) return;

            try {
                await batchAddCustomer(this.file);
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Success',
                        icon: 'CheckIcon',
                        variant: 'success',
                        message: 'Customers added successfully!'
                    }
                });
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        message: "Error adding customers!"
                    }
                });
            }
        }
    }
}
</script>